import { Flex, Stack, Icon, Heading } from '@backyard-ui/core'
import { memo } from 'react'

import { ArrowBackRegular } from 'scripts/react-components/shared/icons'
import { ShopResume } from 'scripts/react-components/checkout/components/MyOrders/components/Shipment/components/ShopResume'

type HeaderProps = {
  shopName: string
  isLMFreight?: boolean
  onBackward?: () => void
}

const Header = (props: Readonly<HeaderProps>) => {
  const { shopName, isLMFreight, onBackward } = props

  const handleBackwards = () => {
    if (onBackward) {
      onBackward()
    } else {
      window.location.href = '/meus-pedidos'
    }
  }

  return (
    <Stack
      direction="column"
      spacing="1"
      className="h-12"
      data-testid="chat-header">
      <Flex align="center" justify="space-between">
        <Stack spacing="2" align="center">
          <a
            className="flex"
            onClick={handleBackwards}
            role="button"
            data-testid="header-backward-button">
            <Icon size="lg">
              <ArrowBackRegular />
            </Icon>
          </a>

          <Heading size="md" color="gray-900">
            Conversa com vendedor
          </Heading>
        </Stack>
      </Flex>
      <ShopResume
        shop={{
          id: shopName === 'Leroy Merlin' ? 'leroy' : 'external',
          name: shopName
        }}
        isLMFreight={isLMFreight}
      />
    </Stack>
  )
}

Header.displayName = 'header'

export default memo(Header)
